import $ from 'jquery'
import 'slick-carousel'

// options at: http://kenwheeler.github.io/slick/

class Carousel {
  constructor(el, userOptions, initCb) {
    $(el).parent().addClass('carousel')
    this.sliderEl = el.querySelector('.slides')

    let options = {
      accessibility: true,
      arrows: false,
      dots: true,
      speed: 1000,
      mobileFirst: true,
      adaptiveHeight: true,
      autoplay: false
    }

    if (userOptions) {
      options = userOptions
    }
    $(el).on('init', () => {
      if (typeof initCb === 'function') initCb()
    })
    $(el).slick(options)

    if (options.autoplay === false) {
      $(el).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        // window.scrollTo(0, $(slick.$slides[nextSlide]).offset().top);
        // console.dir(event)
        // console.dir(slick)
        // console.dir($(slick.$slides[nextSlide]).offset().top)
        $('html, body').animate({
          scrollTop: $(slick.$slides[nextSlide]).offset().top - $('header').outerHeight()
        }, 1000)
      })
    }
  }
}

export default Carousel



// WEBPACK FOOTER //
// ./js/classes/carousel.class.js